import { createContext } from "react";
import { IPrizeContext } from "./modalClaim.types";

export const PrizeContext = createContext<IPrizeContext | undefined>(undefined);
